"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Modal_1 = __importDefault(require("@components/Modal"));
var react_i18next_1 = require("react-i18next");
var Tree_1 = require("@features/ItemCommon/components/common/SelectTree/Tree/Tree");
var Button_1 = __importStar(require("@components/Button"));
function TreeModal(_a) {
    var categories = _a.categories, current = _a.current, resetToOriginalValue = _a.resetToOriginalValue, setCategory = _a.setCategory;
    var _b = __read(react_1.default.useState(true), 2), isOpen = _b[0], setIsOpen = _b[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var _c = __read(react_1.default.useState(current), 2), tempCategory = _c[0], setTempCategory = _c[1];
    return (react_1.default.createElement(Modal_1.default, { isOpen: isOpen, setIsOpen: function (isOpen) {
            resetToOriginalValue();
            setIsOpen(isOpen);
        } },
        react_1.default.createElement("div", { className: "edit-tree-modal" },
            react_1.default.createElement("div", { className: "highlight row" },
                react_1.default.createElement("div", { className: "col-md-12" },
                    react_1.default.createElement("h3", { className: "heading" },
                        t('ITEM.CATEGORY'),
                        ":",
                        ' ',
                        react_1.default.createElement("em", null,
                            react_1.default.createElement("strong", null, current.name))))),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "tree col-md-12" },
                    react_1.default.createElement(Tree_1.Tree, { categories: categories, tempCategory: tempCategory, setTempCategory: setTempCategory }))),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-md-12" },
                    react_1.default.createElement("div", { className: "edit-value-in-tree__button-group" },
                        react_1.default.createElement(Button_1.SecondaryButton, { text: t('ITEM.EDIT_CATEGORY_MODAL.CANCEL_BUTTON'), onClick: function () {
                                resetToOriginalValue();
                                setIsOpen(false);
                            } }),
                        react_1.default.createElement(Button_1.default, { text: t('ITEM.EDIT_CATEGORY_MODAL.SAVE_BUTTON'), onClick: function () {
                                setCategory(tempCategory);
                                setIsOpen(false);
                            } })))))));
}
exports.default = TreeModal;
